import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import backIcon from "../../assets/backIcon.png";
import StepOne from "./step_one";
import StepTwo from "./step_two";
import StepThree from "./step_three";
import StepFour from "./step_four";
import { useEmployee } from "../../context/EmployeeContext";
import { getEmployeeDetails } from "../../api/employeesApi";

const EditEmployeeDetail = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [stepFromUrl, setStepFromUrl] = useState();
  // const stepFromUrl = parseInt(searchParams.get("step")) || 1;
  const { setEmployeeData } = useEmployee();
  const companyId = "com_affa65d93030f0118b3d6045bdc7c627";
  const employeeId = "emp_55b194e8f530f0118b3d6045bdc7c627";

  useEffect(() => {
    const step = parseInt(searchParams.get("step")) || 1;
    setStepFromUrl(step);
  }, [searchParams]);

  useEffect(() => {
    if (!searchParams.get("step")) {
      setSearchParams({ step: "1" });
    }
  }, [searchParams, setSearchParams]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getEmployeeDetails(companyId, employeeId);
        if (res?.data && typeof res.data === "object") {
          setEmployeeData(res.data);
        }
      } catch (error) {
        console.error("Error fetching employee details:", error);
      }
    };
    fetchData();
  }, []);

  const goToStep = (step) => {
    setSearchParams({ step: step.toString() });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    goToStep(4);
  };

  const renderStep = () => {
    switch (stepFromUrl) {
      case 1:
        return <StepOne setStepFromUrl={setStepFromUrl} />;
      case 2:
        return <StepTwo setStepFromUrl={setStepFromUrl} />;
      case 3:
        return <StepThree setStepFromUrl={setStepFromUrl} />;
      case 4:
        return <StepFour setStepFromUrl={setStepFromUrl} />;
      default:
        return <StepOne setStepFromUrl={setStepFromUrl} />;
    }
  };

  return (
    <div className="p-4">
      <div className="d-flex align-items-center">
        <img
          src={backIcon}
          onClick={() => navigate("/manage-employee")}
          alt=""
          style={{
            width: "14px",
            margin: "-6px 6px 0px 0px",
            cursor: "pointer",
          }}
        />
        <h4 className="mb-2 main-title-for-all">Edit Employee Details</h4>
      </div>

      <p className="gray-text-for-content mb-4">
        Select a step below to view or make changes.
      </p>

      <form
        className="mb-4 p-4 bg-white rounded d-flex min-vh-85 flex-column justify-content-between"
        onSubmit={handleSubmit}
      >
        {renderStep()}

        {/* {stepFromUrl < 4 ? (
          <div className="d-flex justify-content-center mt-4">
            {stepFromUrl > 1 && (
              <button
                type="button"
                onClick={() => goToStep(stepFromUrl - 1)}
                className="cancel-button px-4 mx-2"
              >
                Back
              </button>
            )}
            <button
              type="button"
              onClick={() => goToStep(stepFromUrl + 1)}
              className="dark-orange-button px-4 mx-2"
            >
              Continue
            </button>
          </div>
        ) : (
          <div className="d-flex justify-content-center mt-4">
            <button
              type="button"
              className="cancel-button px-4 mx-2"
              onClick={() => goToStep(1)}
            >
              Back to edit
            </button>
            <button type="submit" className="dark-orange-button px-4 mx-2">
              Submit
            </button>
          </div>
        )} */}
      </form>
    </div>
  );
};

export default EditEmployeeDetail;
